var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { initialState, reducer } from "../../common/context/context";
import { Outline } from "../../common/enums/outline";
import { AspectRatio } from "../../common/enums/ratio";
import Icons from "../../icons";
import { ApiI18 } from "../../network/api";
import { LinkButton } from "../_common/button/button.styles";
import { LangHelper } from "../_common/lang/helper";
import LangMessage from "../_common/lang/message";
import LoadingBar from "../_common/loadingBar/loadingBar";
import { SelectedBackDropBlock, SelectedBackDropImg, SelectedBackDropBg, SelectedBackDropMes, SelectedBackDropText, GuideLinesBlock, GuideLine, GuideBg, GuideImg, SelectedBackDropImgAndPNG } from "./selectedBackDrop.styles";
var imagesForCompositionSedan = [
    "",
    "/sedan/06-front-right.png",
    "/sedan/01-back.png",
    "/sedan/02-back-left.png",
    "/sedan/03-side-left.png",
    "/sedan/04-front-left.png",
    "/sedan/05-front.png",
    "/sedan/07-side-right.png",
    "/sedan/08-back-right.png"
];
var imagesForCompositionSuv = [
    "",
    "/suv/06-front-right.png",
    "/suv/01-back.png",
    "/suv/02-back-left.png",
    "/suv/03-side-left.png",
    "/suv/04-front-left.png",
    "/suv/05-front.png",
    "/suv/07-side-right.png",
    "/suv/08-back-right.png"
];
var imagesForCompositionMoto = [
    "",
    "/moto/06-front-right.png",
    "/moto/01-back.png",
    "/moto/02-back-left.png",
    "/moto/03-side-left.png",
    "/moto/04-front-left.png",
    "/moto/05-front.png",
    "/moto/07-side-right.png",
    "/moto/08-back-right.png"
];
var indexToImageNumber = function (i) {
    var imageNumber = 45;
    switch (i) {
        case 1:
            imageNumber = 27;
            break;
        case 2:
            imageNumber = 30;
            break;
        case 3:
            imageNumber = 26;
            break;
        case 4:
            imageNumber = 38;
            break;
        case 5:
            imageNumber = 28;
            break;
        case 6:
            imageNumber = 34;
            break;
        case 7:
            imageNumber = 35;
            break;
        case 8:
            imageNumber = 25;
            break;
    }
    return imageNumber;
};
export var SelectedBackDrop = function (_a) {
    var _b;
    var baseImgURL = _a.baseImgURL, selectedBackDrop = _a.selectedBackDrop, activeTabCarType = _a.activeTabCarType, activeTabABOType = _a.activeTabABOType, overlayImageSrc = _a.overlayImageSrc, customersTag = _a.customersTag, isCustomer = _a.isCustomer, selectedGuideLineIndex = _a.selectedGuideLineIndex, setSelectedGuideLineIndex = _a.setSelectedGuideLineIndex;
    var state = React.useReducer(reducer, initialState)[0];
    var _c = useState(false), generatingImage = _c[0], setGeneratingImage = _c[1];
    var getImgUrl = function (activeTabCarType) {
        if (activeTabCarType) {
            switch (activeTabCarType) {
                case "Sedan":
                    return "".concat(baseImgURL).concat(imagesForCompositionSedan[selectedGuideLineIndex >= imagesForCompositionSedan.length
                        ? imagesForCompositionSedan.length - 1 : selectedGuideLineIndex]);
                case "Suv":
                    return "".concat(baseImgURL).concat(imagesForCompositionSuv[selectedGuideLineIndex]);
                case "Moto":
                    return "".concat(baseImgURL).concat(imagesForCompositionMoto[selectedGuideLineIndex >= imagesForCompositionMoto.length
                        ? imagesForCompositionMoto.length - 1 : selectedGuideLineIndex]);
                default:
                    return "";
            }
        }
        return "";
    };
    var _d = useState(""), message = _d[0], setMessage = _d[1];
    var _e = useState(true), loadingSelectedBackDrop = _e[0], setLoadingSelectedBackDrop = _e[1];
    var _f = useState(''), showBackdropImage = _f[0], setShowBackdropImage = _f[1];
    var _g = useState(0), rotatingImageIdx = _g[0], setRotatingImageIdx = _g[1];
    var _h = useState(0), timeoutId = _h[0], setTimeoutId = _h[1];
    // const [timeoutIdNext, setTimeoutIdNext] = useState<number>(0);
    // const [progressWidth, setProgressWidth] = useState(0);
    useEffect(function () {
        switch (activeTabABOType) {
            case "ABO Standard":
                setMessage(LangHelper.getLangMessageValue("CustDashboard.warningGadArt.Standard", state.lang));
                break;
            case "ABO Premium":
                setMessage(LangHelper.getLangMessageValue("CustDashboard.warningGadArt.Premium", state.lang));
                break;
            case "ABO Premium+":
                setMessage(LangHelper.getLangMessageValue("CustDashboard.warningGadArt.Premium+", state.lang));
                break;
            default:
                setMessage("");
                break;
        }
    }, [activeTabABOType]);
    useEffect(function () {
        var _a, _b, _c;
        if ((_a = selectedBackDrop[0]) === null || _a === void 0 ? void 0 : _a.image) {
            setLoadingSelectedBackDrop(false);
            setShowBackdropImage((_b = selectedBackDrop[0]) === null || _b === void 0 ? void 0 : _b.image);
            if ((_c = selectedBackDrop[0].showroom) === null || _c === void 0 ? void 0 : _c.length) {
                setRotatingImageIdx(1);
            }
            else {
                setRotatingImageIdx(0);
            }
        }
        if (selectedGuideLineIndex && !generatingImage && activeTabCarType) {
            setGeneratingImage(true);
            compositeBackdrop("".concat(getImgUrl(activeTabCarType)), selectedGuideLineIndex);
        }
    }, [selectedBackDrop, activeTabCarType]);
    var guideLines = activeTabCarType === 'Sedan'
        ? imagesForCompositionSedan.map(function (src, index) { return createGuideLine(src, index); })
        : activeTabCarType === 'Suv'
            ? imagesForCompositionSuv.map(function (src, index) { return createGuideLine(src, index); })
            : activeTabCarType === 'Moto'
                ? imagesForCompositionMoto.map(function (src, index) { return createGuideLine(src, index); })
                : [];
    var rotate3d = function (i) {
        guideLines[i].onClick();
    };
    useEffect(function () {
        var _a;
        if (rotatingImageIdx === 1 && ((_a = selectedBackDrop[0].showroom) === null || _a === void 0 ? void 0 : _a.length)) {
            clearTimeout(timeoutId);
            setTimeoutId(0);
            rotate3d(1);
        }
        else {
            clearTimeout(timeoutId);
            setTimeoutId(0);
        }
    }, [rotatingImageIdx, selectedBackDrop]);
    var compositeBackdrop = function (imageUrl, selectedGuideLineIndex) {
        var _a;
        if ((selectedBackDrop === null || selectedBackDrop === void 0 ? void 0 : selectedBackDrop.length) && selectedGuideLineIndex) {
            var imageNumber = indexToImageNumber(selectedGuideLineIndex);
            // const showroom = selectedBackDrop[0]?.showroom?.filter((it: any) => it.guidelines?.includes(imageNumber));
            // if (showroom?.length) {
            //   setShowBackdropImage(showroom[0]?.imagePath)
            // }
            var params = {
                backdropId: (_a = selectedBackDrop[0]) === null || _a === void 0 ? void 0 : _a._id,
                imageNumber: imageNumber,
                imageUrl: imageUrl.replace("".concat(baseImgURL, "/"), ''),
                outline: Outline.E,
                ratio: AspectRatio.A4_3,
            };
            ApiI18.compositeBackdrop(params).then(function (res) {
                var compositedImageUrl = res.data.payload;
                setShowBackdropImage("".concat(compositedImageUrl, "?q=").concat(Date.now()));
            }).catch();
        }
    };
    function createGuideLine(src, index) {
        return {
            alt: "GuideImg ".concat(index),
            isSelected: selectedGuideLineIndex === index,
            onClick: function () {
                var _a;
                setGeneratingImage(true);
                setSelectedGuideLineIndex(index);
                if (index && !overlayImageSrc) {
                    compositeBackdrop("".concat(baseImgURL).concat(src), index);
                }
                else {
                    setShowBackdropImage((_a = selectedBackDrop[0]) === null || _a === void 0 ? void 0 : _a.image);
                }
            },
            src: src === '' ? src : "".concat(baseImgURL).concat(src)
        };
    }
    // const setProgress = (width: number) => {
    //   if (width <= 100) {
    //     setProgressWidth(width)
    //     const newTimeoutId = setTimeout(() => {
    //       setProgress(width + 1)
    //     }, 50)
    //     setTimeoutIdNext(Number(newTimeoutId))
    //   }
    // }
    var loadImage = function () {
        setGeneratingImage(false);
        // clearTimeout(timeoutIdNext)
        // setTimeoutIdNext(0)
        // setProgressWidth(0)
        if (rotatingImageIdx) {
            var newTimeoutId = setTimeout(function () {
                if (rotatingImageIdx < 8) {
                    rotate3d(rotatingImageIdx + 1);
                    setRotatingImageIdx(rotatingImageIdx + 1);
                }
                else {
                    rotate3d(1);
                    setRotatingImageIdx(1);
                }
            }, 5000);
            setTimeoutId(Number(newTimeoutId));
            // setProgress(1);
        }
    };
    return (_jsxs(SelectedBackDropBlock, { children: [loadingSelectedBackDrop ? (_jsx(LoadingBar, { isLoading: loadingSelectedBackDrop })) : (_jsxs(SelectedBackDropImgAndPNG, { children: [_jsx(SelectedBackDropImg, { src: overlayImageSrc
                            ? "".concat(baseImgURL, "/").concat(overlayImageSrc, "/").concat((_b = selectedBackDrop[0]) === null || _b === void 0 ? void 0 : _b.image, " ")
                            : "".concat(baseImgURL, "/").concat(showBackdropImage), onLoad: loadImage }), generatingImage && _jsx("span", __assign({ style: { left: '50%', position: 'absolute', top: '50%', transform: 'translate(-50%, -50%)' } }, { children: _jsx(LoadingBar, { isLoading: generatingImage, isShowMsg: false }) })), message && customersTag !== activeTabABOType && isCustomer && (_jsxs(_Fragment, { children: [_jsx(SelectedBackDropBg, {}), _jsxs(SelectedBackDropMes, { children: [_jsx(SelectedBackDropText, { dangerouslySetInnerHTML: { __html: message } }), _jsx(LinkButton, __assign({ "$size": "medium", "$bgColour": "blue", href: "mailto:support@pixel24.world", target: "__blanck" }, { children: _jsx(LangMessage, { msgKey: "CustDashboard.warningGadArt.Button" }) }))] })] }))] })), _jsx(GuideLinesBlock, { children: guideLines.map(function (guideLine, index) { return (_jsxs(GuideLine, __assign({ "$selectGuideLine": guideLine.isSelected, onClick: generatingImage ? function () {
                        clearTimeout(timeoutId);
                        setTimeoutId(0);
                    } : function () {
                        setTimeoutId(0);
                        setRotatingImageIdx(0);
                        guideLine.onClick();
                        clearTimeout(timeoutId);
                    } }, { children: [_jsx(GuideBg, { src: Icons.transparent, alt: "transparentBg", "$selectGuideLine": guideLine.isSelected }), _jsx(GuideImg, { src: guideLine.src !== "" ? guideLine.src : Icons.nA, alt: guideLine.alt })] }), index)); }) })] }));
};
